export default {
  employeeUSDental: {
    name: 'employeeUSDental',
    groups: [
      {
        title: 'Member Policy Details',
        fields: [
          {
            name: 'policy_id',
            span: 6,
          },
          {
            name: 'benefit_activation_date',
            span: 6,
          },
        ],
      },
      {
        title: 'Employer Policy Details',
        fields: [
          {
            name: 'parent.benefit_start_date',
            span: 6,
          },
          {
            name: 'parent.benefit_end_date',
            span: 6,
          },
          {
            name: 'parent.policy_id',
            span: 6,
          },
          {
            name: 'parent.documents',
            span: 12,
          },
        ],
      },
      {
        title: 'Benefit Setup',
        fields: [
          {
            name: 'parent.prevent_default_allocation',
            span: 4,
          },
          {
            name: 'parent.opt_out',
            span: 4,
          },
          {
            name: 'parent.benefit_waiting_period_months',
            span: 4,
          },
        ],
      },
      {
        title: 'Benefit Expiry',
        fields: [
          {
            name: 'parent.benefit_available_grace_period_days',
            span: 6,
          },
          {
            name: 'parent.auto_renew',
            span: 6,
          },
        ],
      },
      {
        title: 'Description of Coverage',
        fields: [
          {
            name: 'parent.in_network_dental_basic_services',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_deductible_family',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_deductible_single',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_diagnostic_services',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_major_services',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_maximum_amount',
            span: 6,
          },
          {
            name: 'parent.in_network_dental_preventive_services',
            span: 6,
          },
          {
            name: 'parent.in_network_orthodontic_services',
            span: 6,
          },
          {
            name: 'parent.network_name',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_basic_services',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_deductible_family',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_deductible_single',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_diagnostic_services',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_major_services',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_maximum_amount',
            span: 6,
          },
          {
            name: 'parent.out_of_network_dental_preventive_services',
            span: 6,
          },
          {
            name: 'parent.out_of_network_orthodontic_services',
            span: 6,
          },
          {
            name: 'parent.preferred_dental_network_available',
            span: 6,
          },
        ],
      },
      {
        title: 'Internal Fields',
        fields: [
          {
            name: 'id',
            span: 4,
          },
          {
            name: 'parent.id',
            span: 4,
          },
          {
            name: 'user_id',
            span: 4,
          },
          {
            name: 'grace_period_start_date',
            span: 4,
          },
          {
            name: 'inactive_date',
            span: 4,
          },
          {
            name: 'reinstated_date',
            span: 4,
          },
          {
            name: 'parent.benefit_vendor_id',
            span: 4,
          },
          {
            name: 'parent.benefit_type',
            span: 4,
          },
          {
            name: 'parent.benefit_product_type',
            span: 4,
          },
          {
            name: 'parent.benefit_status',
            span: 4,
          },
          {
            name: 'parent.provider_type',
            span: 6,
          },
          {
            name: 'parent.plan_id',
            span: 6,
          },
          {
            name: 'parent.renewed_from',
            span: 6,
          },
          {
            name: 'parent.physical_card',
            span: 6,
          },
          {
            name: 'parent.provider_id',
            span: 6,
          },
          {
            name: 'dependent_coverage',
            span: 6,
          },
          {
            name: 'parent.dependent_classes',
            span: 12,
          },
        ],
      },
    ],
  },
};
